import { CardBody, Input, Label } from "reactstrap";
import { JOB_TITLE_DATA } from "../../../../Data/JobSearch";

const JobTitleCheckBox = () => {
  return (
    <CardBody className="animate-chk">
      {JOB_TITLE_DATA.map((data, index) => (
        <Label className="d-block" for={`check-${index}`} key={index} check>
          <Input className="checkbox_animated" id={`check-${index}`} type="checkbox" />
          {data.JobTitle}({data.JobNumber})
        </Label>
      ))}
    </CardBody>
  );
};

export default JobTitleCheckBox;
